export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-export-csv-6406367b4a0935a4c0527a61f2303933.svg";